// Lista de dominios europeos para facilitar mantenimiento futuro
export const EUROPEAN_DOMAINS = ['https://telefonica.admin.egg.live']

// Función mejorada que verifica si el dominio actual es europeo
export const isEuropeanDomain = (): boolean => {
    const currentOrigin = window?.location?.origin ?? ''
    return EUROPEAN_DOMAINS.includes(currentOrigin)
}

// Tipos y helper para construir URLs con query params
export type QueryParams = Record<string, string | number | boolean | Array<string | number | boolean> | null | undefined>

// Construye un path relativo agregando los query params codificados.
// Arrays se unen por comas (ej: cohorts), y valores undefined/null se omiten.
export const buildPathWithQuery = (path: string, params: QueryParams = {}): string => {
    const search = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) return
        if (Array.isArray(value)) {
            // Unir arrays por coma para mantener compatibilidad existente
            if (value.length > 0) search.append(key, value.map(String).join(','))
        } else {
            search.append(key, String(value))
        }
    })

    const qs = search.toString()
    if (!qs) return path
    // Si el path ya tiene ?, concatenar con &
    return `${path}${path.includes('?') ? '&' : '?'}${qs}`
}
